import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VgOverlayDanmu } from './vg-overlay-danmu';
import { BulletComponent } from './bullet/bullet.component';
import { BulletStyleService } from '../../danmu/bullet.style.service';
// import { NewBulletComponent } from './new-bullet/new-bullet.component';
//import { ContextMenuModule } from 'ngx-contextmenu';
import { SharedModule } from 'app/components/shared.module';
import { PipesModule } from 'app/_pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
     //   ContextMenuModule.forRoot(),
        SharedModule,
        PipesModule,
    ],
    declarations: [
        VgOverlayDanmu,
        BulletComponent,
        // NewBulletComponent,
    ],
    exports: [
        VgOverlayDanmu,
    ],
    // entryComponents: [
    //     BulletComponent,
    //     // NewBulletComponent
    // ],
    providers: [
        BulletStyleService
    ]
})
export class VgOverlayDanmuModule { }
